<div class="date-picker-wrapper">
    <ng-content select=".label"></ng-content>
    <button
        class="calendar-button"
        [disabled]="disabled"
        (keyup.esc)="close($event)"
        (click)="toggle($event)"
        (mouseenter)="onMouseEnter($event)"
        [attr.aria-expanded]="opened"
        tabindex="0">
            <div class="date-input" (keydown.enter)="toggle($event)"><ng-content select=".date-input"></ng-content></div>
            <finder-font-icon name="calendar-month" title="Calendar" size="s"></finder-font-icon>
            <div class="content"><ng-content select=".date-text"></ng-content></div>
            <span class="date-default-text" *ngIf="dateText">{{dateText}}</span>
    </button>
    <finder-calendar
        class="calendar"
        [labels]="labels"
        [hidden]="!opened"
        [attr.aria-hidden]="!opened"
        [(date)]="date"
        (calendarClose)="close($event)"
        [weekDayNameLength]="weekDayNameLength"
        [highlightedDates]="highlightedDates"
        [maxDays]="maxDays"
        (dateSelected)="onDateSelected($event)"
        (mouseleave)="onMouseLeave($event)"
    >
    </finder-calendar>
</div>
